import React, { useRef, useState } from "react";
import { Button, Column, MasterDetail, Summary, TotalItem } from "devextreme-react/data-grid";
import LVGridCabeceraSeleccionDeFiltro from "../../Componentes/Basicos/LVGridCabeceraSeleccionDeFiltro";
import { PaginaListado } from "../../Componentes/Compuestos/Paginas/PaginaListado";
import CON_OperacionesParaImportar_Detalle from "./CON_OperacionesParaImportar_Detalle";
import LVButtonNuevo from "../../Componentes/Basicos/LVButtonNuevo";
import LVButtonReporte from "../../Componentes/Basicos/LVButtonReporte";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { function_CON_Plantilla_OperacionesParaImportar_Cabecera_Generar_JSON, 
  function_CON_Plantilla_OperacionesParaImportar_Cabecera_Insertar, 
  function_CON_Plantilla_OperacionesParaImportar_Cabecera_Leer, 
  function_CON_Plantilla_OperacionesParaImportar_Cabecera_Listar } from "neftis7_apicaller/src/funciones/CONT/CON_Plantilla_OperacionesParaImportar_Cabecera";
import { function_CON_OperacionesParaImportar_Generar } from "neftis7_apicaller/src/funciones/CONT/CON_OperacionesParaImportar";

export const CON_OperacionesParaImportar_ = () => {
  const [data, setData] = useState([])
  const { CON_OperacionesParaImportar: { function_CON_OperacionesParaImportar_Listar, function_CON_OperacionesParaImportar_ListarSoloSinGenerar } } = require('neftis7_apicaller');
  const refRecargaListado = useRef(null);
  const refGrid = useRef(null);

  const handleDataLoaded = (data) => {
    setData(data);
  };

  const onClickDelete = (e) => {
    const Item = { ...e.row.data };
    if (window.confirm('¿Está seguro que desea eliminar este registro?')) {

      const setData = async () => {
        try {
          //await function_NOEXISTE(Item.IdDocVenta)
          refRecargaListado.current?.();
        } catch (error) {
          alert(error);
        }
      }
      setData();
    }
  };

  const handleOnClickGenerar = () => {
    if (window.confirm('¿Está seguro que desea generar las operaciones seleccionadas?')) {

      const generar = async () => {
        try {
          const gridInstance = refGrid.current?.instance;
          if (!gridInstance) {
            alert("No se pudo acceder a la grilla");
            return;
          }

          const visibles = refGrid.current?.instance.getVisibleRows().map(row => row.data);

          let ContadorExito = 0
          let ContadorError = 0
          let MensajeError = ""
          for (const item of visibles) {
            try {
              const responseOperaciones = await function_CON_OperacionesParaImportar_Generar(item.IdItem, localStorage.getItem("Terminal"), localStorage.getItem("IdPersona"))

              console.log(`Item ${item.IdItem}:`);
              console.log(responseOperaciones)

              if (responseOperaciones.data.IdOperacion1 > 0) {
                ContadorExito = ContadorExito + 1
              } else {
                ContadorError = ContadorError + 1
                MensajeError = MensajeError + "La Operación Nº " + item.IdItem + " informó el error: " + responseOperaciones.data.Mensaje + " "
              }
            } catch (error) {
              ContadorError = ContadorError + 1
              MensajeError = MensajeError + "La Operación Nº " + item.IdItem + " informó el error: " + error + ". "
            }
          }

          if (ContadorError > 0) {
            alert(MensajeError);
          }

          if (ContadorExito > 0) {
            alert("Se han generado " + ContadorExito + " operaciones exitosas. ");
            refRecargaListado.current?.(); // refrescar la grilla
          }
        } catch (error) {
          alert(error);
        }
      }

      generar();
    }
  };

  return (
    <PaginaListado
      Titulo="IMPORTADOR DE OPERACIONES"
      funcion={function_CON_OperacionesParaImportar_ListarSoloSinGenerar}
      onDataLoaded={handleDataLoaded}
      refRecarga={refRecargaListado}
    >
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>
          <LVButtonNuevo Url="/CON_OperacionesParaImportar_ModificacionCreacion/--NUEVO--" visible={false} />
          <LVButtonReporte Texto={"PLANTILLAS"} Url="/CON_OperacionesParaImportar_Plantilla" visible={true} />
          <LVButtonReporte Texto={"IMPORTAR DE EXCEL"} Url="/CON_OperacionesParaImportar_Importacion" />
          <LVButtonAccion Texto={"GENERAR"} onClick={handleOnClickGenerar} />
        </div>
        {data.length > 0 ? (
          <LVGridCabeceraSeleccionDeFiltro
            dataSource={data}
            id="gridContainer"
            keyExpr="IdItem"
            ref={refGrid}
            urlEdicion="/CON_OperacionesParaImportar_ModificacionCreacion"
          >
            <Summary>
              <TotalItem
                column="IdItem"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />
              <TotalItem
                column="Importe"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />
            </Summary>

            <Column type="buttons" name="Eliminar" width={40}>
              <Button name="Eliminar" icon="trash" onClick={onClickDelete} visible={false} />
            </Column>

            <Column caption="Código" dataField="IdItem" width="120" alignment="Right" dataType="number" />
            <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
            <Column caption="Fecha" dataField="FechaSinHora" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} visible={false} />
            <Column caption="Descripción" dataField="Descripcion" width="100%" minWidth={100} alignment="Left" dataType="string" />
            <Column caption="Cantidad" dataField="Cantidad" width="100" alignment="Right" dataType="number" />
            <Column caption="Total" dataField="Importe" width="150" alignment="Right" dataType="number" format="currency" />
            <Column caption="Factura" dataField="Factura" width="100" alignment="Left" dataType="string" />
            <Column caption="Artículo" alignment="Center">
              <Column caption="Código" dataField="CodigoArticulo" width="70" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="ABM_ART_Articulos_Descripcion" width="200" alignment="Left" dataType="string" />
            </Column>
            <Column caption="SubCentro Costo" alignment="Center">
              <Column caption="Código" dataField="CodigoSubCC" width="70" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="ABM_CON_SubCentrosCosto_Descripcion" width="200" alignment="Left" dataType="string" />
            </Column>
            <Column caption="Cuenta Financiera" alignment="Center">
              <Column caption="Código" dataField="CodigoCuentaFinanciera" width="70" alignment="Left" dataType="string" />
              <Column caption="Descripción" dataField="ABM_CON_CuentasFinancieras_Descripcion" width="200" alignment="Left" dataType="string" />
            </Column>

            <Column caption="Presentación" alignment="Center" visible={false}>
              <Column caption="Código" dataField="CodigoPresentacion" width="70" alignment="Left" dataType="string" visible={false} />
              <Column caption="Descripción" dataField="ABM_ART_Presentaciones_Descripcion" width="200" alignment="Left" dataType="string" visible={false} />
            </Column>
            <Column caption="Tamaño" alignment="Center" visible={false}>
              <Column caption="Código" dataField="CodigoTamano" width="70" alignment="Left" dataType="string" visible={false} />
              <Column caption="Descripción" dataField="ABM_ART_Tamanos_Descripcion" width="200" alignment="Left" dataType="string" visible={false} />
            </Column>
            <Column caption="Unidad de Medida" alignment="Center" visible={false}>
              <Column caption="Código" dataField="CodigoUnidadMedida" width="70" alignment="Left" dataType="string" visible={false} />
              <Column caption="Descripción" dataField="ABM_ART_UnidadesMedida_Descripcion" width="200" alignment="Left" dataType="string" visible={false} />
            </Column>

            <Column caption="Proveedor" dataField="ABM_EEX_Proveedores_RazonSocial" width="100" alignment="Left" dataType="string" />
            <Column caption="Cliente" dataField="ABM_EEX_Clientes_RazonSocial" width="100" alignment="Left" dataType="string" />
            <Column caption="Tipo Documento" dataField="TipoDocumento" width="100" alignment="Left" dataType="string" />
            <Column caption="Cuotas" dataField="Cuotas" width="70" alignment="Right" dataType="number" />

            <MasterDetail
              enabled={true}
              component={CON_OperacionesParaImportar_Detalle}
            />
          </LVGridCabeceraSeleccionDeFiltro>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaListado>
  );
};
